
export abstract class AppConfig {   
  urlKeysApi: string;
}  
